export default __webpack_public_path__ + "static/basaksehir-logo-b19782b99add62033c55465fc396bea7.png";